import styled from "styled-components";

export const ProgressBar = (props) => {
  const { progress } = props;

  return (
    <ProgressBarDiv style={{ "--progress": `${progress}%` }}>
      <Filled />
    </ProgressBarDiv>
  );
};

const ProgressBarDiv = styled.div`
  background-color: #ebedf3;
  border-radius: 5px;
  height: 5px;
`;

const Filled = styled.div`
  background-color: #1bc5bd;
  border-radius: inherit;
  height: inherit;
  width: var(--progress);
`;
